<style lang="less" scoped>
  @import '../global.less';
  /*左侧导航栏样式*/
  .topAndMenu .Left {position:fixed;left:0;padding-top: 60px;width:200px;z-index:1;float:left;height:100%;overflow-x:hidden;background-color:#324157;transition: all .15s ease-out;}
  /*左侧导航栏【仪表盘】样式*/
  .topAndMenu .Left .routerlink .el-menu-item{ color:#ffffff; }
  .topAndMenu .Left .routerlink>span{height:20px;line-height:20px;font-size:16px; cursor:pointer; color:#f1f1f1;  }
  .topAndMenu .isactive{color:#20a0ff;}

  /*移动端【导航栏看板】样式*/
  .topAndMenu .isMoreList{background-color: #fff;width: 100%;height: 100%;position: absolute;left: 0px;z-index: 99999;margin-top: 60px;}
  /*顶部导航栏样式*/
  .topAndMenu .top{position:fixed;top:0;background-color:#324157;height:60px;width:100%;line-height:20px;z-index:1999;text-align:left;font-size:20px;font-weight:bold;color:@topFont;display: flex; justify-content: space-between;align-items: center;}
  /*顶部导航栏【Menu】样式*/
  .topAndMenu .top .topMenuList{  padding-left:20px ;    width: 80%;  height:100%;display: flex;align-items: center;}
  /*改变导航栏【背景】颜色
  .el-menu--dark{background-color:@topBack!important;}*/
  /*导航栏文字超出范围隐藏*/
  .topAndMenu .Left .el-menu li{overflow: hidden;text-overflow: ellipsis;width: 100%;}
  /*顶部导航栏【标题】样式*/
  .topAndMenu .top .topMenuList .title{text-shadow:0px 0px 45px fade(@baseFontColor,40%);display:block;white-space:nowrap; overflow:hidden; text-overflow:ellipsis;}
  /*顶部导航栏用户操作样式*/
  .topAndMenu .top .top-right{
    cursor: pointer;
    margin-left: 20px;
    padding: 0 2px;
    font-weight: 100;
    height: 100%;
    line-height: 60px;
    vertical-align: middle;
  }


  /*左侧导航栏收缩*/
  .topAndMenu .showMenu{ position: absolute;left: 200px;top:0;background-color: #ffffff; height: 100%;width: 14px;z-index: 1;cursor: pointer;transition: all .15s ease-out;}
  .topAndMenu .showMenuLeft{background: url("../assets/imgs/menuLeft.png") no-repeat; background-size: contain;width: 14px;height: 14px;margin-top: 500px;}
  .topAndMenu .showMenuRight{background: url("../assets/imgs/menuRight.png") no-repeat;background-size: contain;width: 14px;height: 14px;margin-top: 500px;}

  /*移动端折叠菜单*/
  .topAndMenu .moreList{cursor: pointer;position: absolute;right: 1rem;top: 0;height: 60px;width: 60px;z-index: 99999;display: none}
  .topAndMenu .moreList i{background: url("../assets/imgs/moreList.png") no-repeat;background-size: contain;height: 30px;width: 30px;top: 20px;right: 15px;position: absolute;}

  /*移动端折叠菜单详情*/
  .topAndMenu .isMoreContent{ position: relative;line-height: 180px;cursor: pointer; overflow:hidden;text-overflow:ellipsis;white-space:nowrap; height: 150px; border-bottom: 1px solid #e6e6e6; border-right: 1px solid #e6e6e6;text-align: center;padding: 0px 3%;  }
  .topAndMenu .isMoreContent i{position: absolute;top: 27%; left: 46%; }


  /*当屏幕小于1200时，隐藏左侧导航栏、用户操作，显示导航栏折叠图标*/
  @media screen and (max-width: 1200px) {
    .Left,.showMenu{display: none}
    .topAndMenu .moreList{display: block;}
    .pull_hide{display: none;}
    .topAndMenu .top .topMenuList {display: none}
  }
  /*当屏幕大于1200时，隐藏移动端导航栏看板*/
  @media screen and (min-width: 1200px) {
    .topAndMenu .isMoreList{display: none!important;}
  }

  /*引入颜色库后删除*/
  .topAndMenu  .isMoreContent .red{color: #01AAED}//是50
  .topAndMenu  .isMoreContent .ego_color1{color: #00bcd4}//
  .topAndMenu  .isMoreContent .ego_color2{color: #ee8c65}//
  .topAndMenu  .isMoreContent .ego_color3{color: #56d413}//
  .topAndMenu  .isMoreContent .ego_color4{color: #c1456f}//
  .topAndMenu  .isMoreContent .ego_color5{color: #d87d26}//
  .topAndMenu  .isMoreContent .ego_color6{color: #7cb5bd}//
  .topAndMenu  .isMoreContent .ego_color7{color: #adb23d}//
  .topAndMenu  .isMoreContent .ego_color8{color: #c5af51}//
  .topAndMenu  .isMoreContent .ego_color9{color: #9996c9}//
  .topAndMenu  .isMoreContent .ego_color10{color: #bb94ae}//
  .topAndMenu  .isMoreContent .ego_color11{color: #c5919b}//
  .topAndMenu  .isMoreContent .ego_color12{color: #85c57e}//
  .topAndMenu  .isMoreContent .ego_color13{color: #9375c5}//
  .topAndMenu  .isMoreContent .ego_color14{color: #c56e7e}//
  //备注
  .topAndMenu  .isMoreContent .ego_color15{color: #a0d8de}//
  .topAndMenu  .isMoreContent .ego_color16{color: #bbe5fa}//
  .topAndMenu  .isMoreContent .ego_color17{color: #c3aad4}//
  .topAndMenu  .isMoreContent .ego_color18{color: #bd8e7c}//
  .topAndMenu  .isMoreContent .ego_color19{color: #f3b78e}//
  .topAndMenu  .isMoreContent .ego_color20{color: #f79990}//
  .topAndMenu  .isMoreContent .ego_color21{color: #bd9d98}//
  .topAndMenu  .isMoreContent .ego_color22{color: #7fa2a2}//
  .topAndMenu  .isMoreContent .ego_color23{color: #c4b362}//
  .topAndMenu  .isMoreContent .ego_color24{color: #eedd66}//
  .topAndMenu  .isMoreContent .ego_color25{color: #d67e7e}//
  .topAndMenu  .isMoreContent .ego_color26{color: #dea0a0}//
  .topAndMenu  .isMoreContent .ego_color27{color: #9fadfb}//
  .topAndMenu  .isMoreContent .ego_color28{color: #d9ccbb}//
  .topAndMenu  .isMoreContent .ego_color29{color: #4b3d4f}//
  .topAndMenu  .isMoreContent .ego_color30{color: #8c3064}//
  .topAndMenu  .isMoreContent .ego_color31{color: #0c7a82}//
  .topAndMenu  .isMoreContent .ego_color32{color: #f5dbc1}//
  .topAndMenu  .isMoreContent .ego_color33{color: #85803a}//
  .topAndMenu  .isMoreContent .ego_color34{color: #c7bd61}//
  .topAndMenu  .isMoreContent .ego_color35{color: #78435e}//
  .topAndMenu  .isMoreContent .ego_color36{color: #8a1145}//
  .topAndMenu  .isMoreContent .ego_color37{color: #00343f}//
  .topAndMenu  .isMoreContent .ego_color38{color: #d0e9ff}//
  .topAndMenu  .isMoreContent .ego_color39{color: #1db0b8}//
  .topAndMenu  .isMoreContent .ego_color40{color: #c3bed4}//
  .topAndMenu  .isMoreContent .ego_color41{color: #0b6e48}//
  .topAndMenu  .isMoreContent .ego_color42{color: #006A80}//
  .topAndMenu  .isMoreContent .ego_color43{color: #5F7896}//
  .topAndMenu  .isMoreContent .ego_color44{color: #B05B5C}//
  .topAndMenu  .isMoreContent .ego_color45{color: #BE7591}//
  .topAndMenu  .isMoreContent .ego_color46{color: #ca8687}//
  .topAndMenu  .isMoreContent .ego_color47{color: #8A3324}//
  .topAndMenu  .isMoreContent .ego_color48{color: #f17c67}//
  .topAndMenu  .isMoreContent .ego_color49{color: #87843b}//
  .topAndMenu  .isMoreContent .ego_color50{color: #BDB76A}//


</style>

<template>
  <div class="topAndMenu">
    <div class="top"><!--顶部导航栏---start-->
      <div class="topMenuList"><!--PC端导航信息，小屏时隐藏---start -->
        <span class="title">第三方接口管理平台</span>
      </div><!--PC端导航信息，小屏时隐藏---end -->
      <div style="width: 20%;height: 100%;    display: flex;justify-content: flex-end;padding-right: 20px;"><!--右侧操作栏包括全屏，注销，用户名称，移动端显示折叠面板---start -->
        <span class="moreList"  @click="leftMoreList">
           <i></i><!--移动端列表-->
        </span>
        <span class="top-right pull_hide"><!--用户名称-->
           <span  class="user" data-toggle="tooltip" >
             <i class="fa fa-user"></i> {{ strByLen(getSsessionUser,5) }}
           </span>
        </span>

        <span  class="top-right pull_hide" @click="sessionUserLogout">
          <img src="../assets/imgs/logOut.png" />
        </span>
      </div> <!--右侧操作栏包括全屏，注销，用户名称，移动端显示折叠面板---end -->
    </div><!--顶部导航栏---end-->


    <div class="cover"></div><!--遮罩-->
    <!-------------jyz-----修改密码表单------end---------------------->

    <div class="Left"><!--左侧导航栏，小屏时隐藏--start -->
      <div class="menu">
        <el-menu default-active="activeIndex" class="el-menu-vertical-demo" @select="menuClick" theme="dark" :collapse="isCollapse">
          <router-link to="/a00299303" class="routerlink">
            <el-menu-item style="padding-left: 15px" index="1">
              <div :class="{isactive: isactive == 1}">
                <i class="egofont ego-a00299303"></i>
                <span slot="title">API接口定义</span>
              </div>
            </el-menu-item>
          </router-link>
          <router-link to="/a00399302" class="routerlink">
            <el-menu-item style="padding-left: 15px" index="2">
              <div :class="{isactive: isactive == 2}">
                <i class="egofont ego-a00399302_b"></i>
                <span slot="title">授权用户维护</span>
              </div>
            </el-menu-item>
          </router-link>
          <!--<template v-for="subitem in SRMenus" v-if="subitem.MenuLevel==2&&fid==subitem.UpMenuID">
            <el-menu-item v-bind:index="subitem.ModuleID"  style="padding-left: 15px">
              <i v-if="subitem.Class=='' " class="fa fa-table"></i>
              <i v-bind:class="subitem.Class" v-else></i>
              <span slot="title">{{subitem.ModuleName}}</span>
            </el-menu-item>
          </template>-->
        </el-menu>
      </div>
    </div>
    <div class="showMenu" @click="showMenu">
      <div class="showMenuLeft"></div>
    </div>
    <!--左侧导航栏，小屏时隐藏--end -->
    <el-collapse-transition><!--移动端导航栏看板--start -->
      <div class="isMoreList" v-show="showMoreList">
        <el-row>
          <el-col :xs="8" :sm="6":md="6"  >
            <router-link to="/a00299303" class="routerlink">
              <div @click="menuClick('a00299303','',true)" class="isMoreContent">
                <i class="egofont ego-a00299303" ></i>API接口定义
              </div>
            </router-link>
          </el-col>
          <el-col :xs="8" :sm="6":md="6"  >
            <router-link to="/a00399302" class="routerlink">
              <div @click="menuClick('a00399302','',true)" class="isMoreContent">
                <i class="egofont ego-a00399302_b" ></i>授权用户维护
              </div>
            </router-link>
          </el-col>
       <!--   <template v-for="subitem in SRMenus" v-if="subitem.MenuLevel==2&&fid==subitem.UpMenuID">
            <el-col :xs="8" :sm="6":md="6">
              <div  class="isMoreContent"   v-bind:index="subitem.ModuleID" @click="menuClick(subitem.ModuleID,[subitem.UpMenuID],true)" >
                <i v-if="subitem.Class=='' " class="egofont ego-t300"></i>
                <i v-bind:class="subitem.Class" style="font-size: 3rem; top: 22%;left: 40%;" v-else></i>{{subitem.ModuleName}}
              </div>
            </el-col>
          </template>-->
        </el-row>
      </div>
    </el-collapse-transition><!--移动端导航栏看板--end -->
  </div>
</template>

<script>
  import util from 'src/util.js';
  import store from 'src/vuex/store'
  import {sessionUser,systemInfo, } from 'src/vuex/getters'
  import {sessionUserLogout } from 'src/vuex/actions'
  export default{
    name:"egolmMainMenu",
    store,
    vuex: {
      getters: {
        sessionUser,systemInfo
      },
      actions: {sessionUserLogout }
    },
    components:{
    },
    data(){
      return {
        index: this.$route.name === 'a00299303'? '1' : '2' ,
        userList:"userList",
        shortuserList:"userListShort",
        //当前用户的菜单
        SystemRoleMenus:{},
        fid:'',
        activeIndex:'1',
        showMoreList: false,
        isCollapse: false,

        //用户修改密码表单
        //用户修改密码下拉列表
        isShowUserList:false,
      }
    },
    //自定义过滤器
    filters:{
      //过滤一级菜单
      level1(menus){
        return menus.filter(x=>{return x.MenuLevel==1})
      },
      //过滤二级菜单
      level2(menus,menuID){
        return menus.filter(x=>{return x.UpMenuID==menuID})
      }
    },
    computed:{
      isactive () {
        return this.index
      },
      getSsessionUser(){
        if(this.sessionUser){
          return this.sessionUser.userName
        }else{
          return ""
        }
      },
      SRMenus(){
        if(this.SystemRoleMenus.dataList){
          return this.SystemRoleMenus.dataList
        }else{
          return []
        }
      },
      getSsessionUserFullName(){
        if(this.sessionUser){
          return this.sessionUser.userId  +'.'+ this.sessionUser.userName
        }else{
          return ""
        }
      },
      //过滤一级菜单
      level1(menus){
        return menus.filter(x=>{return x.MenuLevel==1})
      },
      //过滤二级菜单
      level2(menus,menuID){
        return menus.filter(x=>{return x.UpMenuID==menuID})
      }
    },
    methods:{
      /*   //点击显示、隐藏二级菜单
       toggleMenu(event){
       $(event.target).nextUntil("dt").slideToggle('fast');
       },*/
      showMenu(){
        this.isCollapse = !this.isCollapse;
        if(this.isCollapse){
          $('.Left').css('width','64px');
          $('.showMenu').css('left','64px');
          $('.Right').css('padding','60px 0 0 79px');
          $('.showMenu div').removeClass('showMenuLeft');
          $('.showMenu div').addClass('showMenuRight');
        }else{
          $('.Left').css('width','200px');
          $('.showMenu').css('left','200px');
          $('.Right').css('padding','60px 0 0 215px');
          $('.showMenu div').removeClass('showMenuRight');
          $('.showMenu div').addClass('showMenuLeft');
        }
      },
      showSubitem(id,name){
        window.localStorage.setItem(util.systemMenuName(),name);
        this.fid = id;
        this.SRMenusInit();
      },
      leftMoreList(){
        //$('.isMoreList').slideToggle(100);
        this.showMoreList = !this.showMoreList;
      },
      //获取菜单信息
      SRMenusInit(){
        let self=this;
        util.myAjax({
          url:util.getUrl()+"/StdQuery/StdQuery",
          dataType:"json",
          async:true,
          data:{
            queryName:"SystemRoleMenus",
            SystemID:"01",
            SystemRoleID:this.systemInfo.systemRoleID,
            UserID:self.sessionUser.userId
          },
          success(data){
            if(data.isValid){
              self.SystemRoleMenus=data.data;
              //console.log(self.SystemRoleMenus);
            }
          }
        });
      },
      //按指定长度截取字符串
      strByLen(str,len){
        return util.strByLen(str,len);
      },
      goHome(){
        router.push('/home');
      },
      getmenuInfo(moduleID,dataList){
        //console.log(moduleID);
        for(var i = 0;i<dataList.length;i++) {
          var item = dataList[i];
          //console.log(item);
          if (item.ModuleID == moduleID)
          {
            //console.log(item.ModuleID);
            return item;
            break;
          }
        }
        return [];
      },
      getMainmenuInfo(MenuID,dataList){
        for(var i = 0;i<dataList.length;i++) {
          var item = dataList[i];
          if (item.MenuID == MenuID) {
            return item;
            break;
          }
        }
        return [];
      },
      menuClick(key, keyPath,show) {
        this.index = key
        if(show){
          this.showMoreList = !this.showMoreList;
        }
        if (keyPath!='') {
          var MainModuleID=keyPath[0];
          var menuInfo = this.getmenuInfo(key,this.SystemRoleMenus.dataList);

          if (menuInfo.length!=0){
            var mainmenuInfo = this.getMainmenuInfo(menuInfo.UpMenuID,this.SystemRoleMenus.dataList);
            var routername='';
            if (menuInfo.FileName == 'SmartQuery.dll')
            {
              routername = 'stdQuery';
            }else
            {
              routername = menuInfo.Url;
            }
            //console.log('routername='+routername);
            //检查用户访问权限，如果没有权限则直接退出
            if (!util.checkUserPower(this.sessionUser.userId,menuInfo.ModuleID))
              return;

            router.push({
              name:routername,
              params:{
                moduleID:menuInfo.ModuleID,
                upmoduleName:mainmenuInfo.ModuleName,
                moduleName:menuInfo.ModuleName
              }
            });
          }
        }else if(key=='home'){
          router.push({
            name:'home'
          });
        }
      },
    },
    mounted(){
      //console.log('systemRoleID='+this.systemInfo.systemRoleID);
      //加载菜单信息
     // console.log(this.$route)
      this.SRMenusInit();
      this.fid = sessionStorage.getItem('home-fid')
    },

    beforeUpdate () {
      const fid = this.fid
      sessionStorage.setItem('home-fid',fid)
    }
  }

</script>



// WEBPACK FOOTER //
// menu.vue?5d020ab7